import {
  initializeSuccess,
  changeLocation,
  clickHeaderButton,
} from '../actions';
import { TRACK_PAGE } from '../constants';
import { extractPathAndHash } from '../utils/url';
import type { RootState } from '../reducers';

export interface TrackEvent {
  eventName: string;
  eventPayload?: Record<string, unknown>;
}

// map redux actions to user tracking events
export default {
  // The TRACK_IDENTIFY event below stopped firing on 2025-03-27 (PR #757):
  // it was defined under the same `[initializeSuccess]` key as app_shell_loaded,
  // and the later duplicate key silently replaced it. The mapping supports only
  // one event per action type, so re-enabling it requires moving one of the two
  // events elsewhere (e.g. an fx effect) AND an analytics-owner decision, since
  // identify data has been absent from dashboards since then.
  // Its consumer branch still exists in src/initializers/track-method.js (case TRACK_IDENTIFY).
  //
  // [initializeSuccess.type]: (
  //   state: RootState,
  //   { myAccountData: { id }, currentMerchantData }: InitializeSuccessPayload
  // ): TrackEvent => ({
  //   eventName: TRACK_IDENTIFY,
  //   eventPayload: {
  //     id,
  //     data: {
  //       'Merchant uuid': currentMerchantData.id,
  //       'Merchant account uuid': id,
  //       id,
  //     },
  //   },
  // }),
  [initializeSuccess.type]: (): TrackEvent => ({
    eventName: 'app_shell_loaded',
  }),
  [changeLocation.type]: (
    state: RootState,
    { url }: { url: string }
  ): TrackEvent => ({
    eventName: TRACK_PAGE,
    eventPayload: {
      properties: {
        path: extractPathAndHash(url),
        url,
      },
    },
  }),
  [clickHeaderButton.type]: (state: RootState, name: string): TrackEvent => ({
    eventName: `header_${name}_click`,
  }),
};
